module.exports = __webpack_public_path__ + "img/background_default.8d8807e1.jpg";